import { Component, Input, Injector, OnInit } from '@angular/core';
import { FormControl, Validators, FormBuilder } from '@angular/forms';
import { LoadingController, ModalController, ToastController } from '@ionic/angular';
import moment from 'moment';

import { endpoints } from 'src/app/constant/endpoints';
import { ApiService } from 'src/app/provider/api.service';
import { DailyMenuDataService } from 'src/app/services/daily-menu-data.service';
import { SubscriptionDateService } from 'src/app/services/subscription-date.service';
import { BasePage } from 'src/app/shared/base-page';

@Component({
  selector: 'app-rating',
  templateUrl: './rating.page.html',
  styleUrls: ['./rating.page.scss'],
  standalone: false,
})
export class RatingPage extends BasePage implements OnInit {
  @Input() date?: any;
  @Input() customer_id?: any;
  @Input() customer_subscription_id?: any;
  @Input() isDoubleBox?: boolean = false;
  loader: boolean = true;
  menuData: any = {};
  selectedFood: any = [];
  customer?: any;
  constructor(
    injector: Injector,
    private toastCtrl: ToastController,
    private modalCtrl: ModalController,
    private apiService: ApiService,
    private dailyMenuDataService: DailyMenuDataService,
    private subscriptionDateService: SubscriptionDateService,
  ) {
    super(injector);
  }

  onRatingChange = (item: any, newRating: number) => {
    if (!item || newRating === undefined) {
      return;
    }

    item.my_rating = newRating;

    const ratingData = {
      rate: newRating,
      menu_item_id: item.id,
      date: this.date,
      customer_id: this.customer_id,
      customer_subscription_id: this.customer_subscription_id,
      comment: item.comment || ''
    };

    this.apiService?.post(endpoints.sendRating, ratingData).subscribe(
      (resp) => {},
      (error) => {
        this.toastMessage('Failed to save rating');
      }
    );
  };
  ngOnInit() {
    this.configService.appSettings$.subscribe((currentSettings: any) => {
      this.settings = currentSettings;
    });
    const authService = this.getAuthService();
    this.customer = authService?.getAuthUser();
    this.loadMenuData();
  }

  ionViewWillEnter() {
  }

  protected override async onPageReady() {
    super.onPageReady();
    const authService = this.getAuthService();
    this.customer = authService?.getAuthUser();
  }
  loadMenuData = async () => {
    this.menuData = {};
    this.selectedFood = [];
    this.loader = true;

    try {
      const state = this.subscriptionDateService.getState();
      const formattedDate = moment(this.date).format('YYYY-MM-DD');
      const dayConfig = state.dayConfigs[formattedDate];
      
      const menuResponse = await this.dailyMenuDataService.getMenuData(
        this.customer.id,
        formattedDate,
        this.isDoubleBox || false,
        this.customer,
        dayConfig?.selectionLimit || {}
      );
      
      this.loader = false;
      
      if (menuResponse?.newNestedArray) {
        const menuBuilders = menuResponse.newNestedArray;
        
        this.menuData = {};
        menuBuilders.forEach((builder: any) => {
          const foodTypeName = builder.food_type_name || builder.type_name || 'Other';
          this.menuData[foodTypeName] = builder;
        });
        
        menuBuilders.forEach((builder: any) => {
          builder.type_data?.forEach((item: any) => {
            if (item.is_selected || item.quantity > 0) {
              this.selectedFood.push(item);
            }
          });
        });
      }
    } catch (error) {
      this.loader = false;
      this.menuData = {};
    }
  };
  emptyObject = (data: any) => {
    if (Object.entries(data).length > 0) {
      return false;
    }
    return true;
  };
  closeModal = () => {
    this.modalCtrl?.dismiss();
  };
  toastMessage = async (msg: any) => {
    await this.toastCtrl
      .create({
        message: this.translate?.instant(msg),
        duration: 4000,
        position: 'top',
        color: 'tertiary',
      })
      .then((toastElem: any) => toastElem.present());
  };
  getParseFloat = (num: any) => {
    return Number(parseFloat(num).toFixed(0));
  };

  override ngOnDestroy() {
    super.ngOnDestroy();
  }
}
